<template>
  <div class="d2-slider">
    <!-- video -->
    <div v-if="sliderCategory == 'Video'"  class="row" ref="videoSlider">
      <div v-for="data in sliderData" :key="data.key"  class="col-12 col-md-4 col-lg-4 col-sm-6 d2-videoItem">
        <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(data.content_id)">
          <div class="d2-videoItem__thumb">
            <img class="img_wrp" :src="data.cover_img" alt="" />
          </div>
          <div class="playBtn"><span></span></div>
          <div class="d2-videoItem__info">
            <!-- <h3 class="mobiTitle sm">{{ hot.content_name }}</h3> -->
            <span v-if="lang_gamebox !== 'english'">
              <h3
                class="d2-h3"
                v-if="data[`cont_name_${lang_gamebox}`] !== ''"
              >
                {{ data[`cont_name_${lang_gamebox}`] }}
              </h3>
              <h3 class="d2-h3" v-else>
                {{ data[`cont_name_english`] }}
              </h3>
            </span>
            <span v-else>
              <h3 class="d2-h3">
                {{ data[`cont_name_english`] }}
              </h3>
            </span>
            <div>
              <!-- <star-rating
                      :inline="true"
                      :star-size="16"
                      :read-only="true"
                      :increment="0.01"
                      active-color="#ffb902"
                      :show-rating="false"
                      :border-width="2"
                      border-color="#feb801"
                      :rounded-corners="false"
                      inactive-color="transparent"
                      :star-points="[
                        23,
                        2,
                        14,
                        17,
                        0,
                        19,
                        10,
                        34,
                        7,
                        50,
                        23,
                        43,
                        38,
                        50,
                        36,
                        34,
                        46,
                        19,
                        31,
                        17
                      ]"
                      :rating="Number(sliderData.rating)"
                    ></star-rating> -->
            </div>
          </div>
        </a>
      </div>
    </div>
    
    <!-- wallpaper -->
    <div v-else-if="sliderCategory == 'Wallpaper'" class="row" ref="wallpaperSlider">
      <div v-for="data in sliderData" :key="data.key"  class="col-4 col-md-2 col-lg-2 col-sm-3 col-2 d2-appItem">
        <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(data.content_id)">
          <div class="d2-appItem__thumb">
            <img class="img_wrp" :src="data.cover_img" alt="" />
          </div>
          <div class="d2-appItem__info">
            <span v-if="lang_gamebox !== 'english'">
              <h4
                class="d2-h4"
                v-if="sliderData[`cont_name_${lang_gamebox}`] !== ''"
              >
                {{ sliderData[`cont_name_${lang_gamebox}`] }}
              </h4>
              <h4 class="d2-h4" v-else>
                {{ sliderData[`cont_name_english`] }}
              </h4>
            </span>
            <span v-else>
              <h4 class="d2-h4">
                {{ data[`cont_name_english`] }}
              </h4>
            </span>
            <div>
          
              <star-rating
                :inline="true"
                :star-size="15"
                :read-only="true"
                :increment="0.01"
                active-color="#FFCF00"
                :show-rating="false"
                :border-width="2"
                border-color="#FFCF00"
                :rounded-corners="false"
                inactive-color="transparent"
                :star-points="[
                  23,
                  2,
                  14,
                  17,
                  0,
                  19,
                  10,
                  34,
                  7,
                  50,
                  23,
                  43,
                  38,
                  50,
                  36,
                  34,
                  46,
                  19,
                  31,
                  17
                ]"
                :rating="Number(data.rating)"
              ></star-rating>
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- game -->
    <div v-else-if="sliderCategory == 'Game'" class="row" ref="gameSlider">
      <div v-for="data in sliderData" :key="data.key" class="col-6 col-md-3 col-lg-2 d2-appItem">
        <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(data.content_id)">
          <div class="d2-appItem__thumb">
            <img class="img_wrp" :src="data.thumbnail_url" alt="" />
          </div>
        
          <div class="d2-appItem__info">
            <!-- <h3 class="mobiTitle sm">{{ hot.content_name }}</h3> -->
            <span v-if="lang_gamebox !== 'english'">
              <h3
                class="d2-h4"
                v-if="data[`cont_name_${lang_gamebox}`] !== ''"
              >
                {{ data[`cont_name_${lang_gamebox}`] }}
              </h3>
              <h3 class="d2-h4" v-else>
                {{ data[`cont_name_english`] }}
              </h3>
            </span>
            <span v-else>
              <h3 class="d2-h4">
                {{ data[`cont_name_english`] }}
              </h3>
            </span>
            <div>
           
              <star-rating
                :inline="true"
                :star-size="14"
                :read-only="true"
                :increment="0.01"
                active-color="#FFCF00"
                :show-rating="false"
                :border-width="2"
                border-color="#FFCF00"
                :rounded-corners="false"
                inactive-color="transparent"
                :star-points="[
                  23,
                  2,
                  14,
                  17,
                  0,
                  19,
                  10,
                  34,
                  7,
                  50,
                  23,
                  43,
                  38,
                  50,
                  36,
                  34,
                  46,
                  19,
                  31,
                  17
                ]"
                :rating="Number(data.rating)"
              ></star-rating>
            </div>
          </div>
        </a>

      </div>
    </div>

    <!-- app -->
    <div v-else class="row" ref="applicationSlider">
      <div v-for="data in sliderData" :key="data.key" class="col-6 col-md-3 col-lg-2 d2-appItem">
        <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(data.content_id)">
          <!-- <router-link class="d2__inner app" :to="{ name: 'DetailPage', params: { id: data.content_id } }"> -->
          <div class="d2-appItem__thumb">
            <img class="img_wrp" :src="data.thumbnail_url" alt="" />
          </div>
        
          <div class="d2-appItem__info">
            <!-- <h3 class="mobiTitle sm">{{ hot.content_name }}</h3> -->
            <span v-if="lang_gamebox !== 'english'">
              <h4 class="d2-h4" v-if="data[`cont_name_${lang_gamebox}`] !== ''">
                {{ data[`cont_name_${lang_gamebox}`] }}
              </h4>
              <h4 class="d2-h4" v-else>
                {{ data[`cont_name_english`] }}
              </h4>
            </span>
            <span v-else>
              <h4 class="d2-h4">
                {{ data[`cont_name_english`] }}
              </h4>
            </span>
            <div>
           
              <star-rating
                :inline="true"
                :star-size="15"
                :read-only="true"
                :increment="0.01"
                active-color="#FFCF00"
                :show-rating="false"
                :border-width="2"
                border-color="#FFCF00"
                :rounded-corners="false"
                inactive-color="transparent"
                :star-points="[
                  23,
                  2,
                  14,
                  17,
                  0,
                  19,
                  10,
                  34,
                  7,
                  50,
                  23,
                  43,
                  38,
                  50,
                  36,
                  34,
                  46,
                  19,
                  31,
                  17
                ]"
                :rating="Number(data.rating)"
              ></star-rating>
            </div>
          </div>
        <!-- </router-link> -->
        </a>

      </div>
    </div>

  
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Flickity from "flickity";
import StarRating from 'vue-star-rating';
export default {
  data() {
    return {
      flickityAppOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        freeScroll: true,
        contain: true
      },
      flickityVideoOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        freeScroll: true,
        contain: true,
        cellAlign: "left",
        resize: true
      },
      stageDragging: false
    };
  },
  computed: mapGetters(["lang_gamebox", "country_gamebox"]),
  props: ["sliderData", "isLoaded", "sliderCategory", "id", "slider_ref"],
  components: {
    "star-rating": StarRating
  },
  mounted() {
    let sliderStatus = false;
    let width = window.innerWidth;
    if (this.$props.isLoaded && this.$props.sliderCategory == "Video") {
      this.$nextTick(() => {
        let videoSliderflkty = new Flickity(
          this.$refs.videoSlider,
          this.flickityVideoOptions
        );
        videoSliderflkty.on("dragStart", function() {
          this.stageDragging = true;
        });
        videoSliderflkty.on("dragEnd", function() {
          this.stageDragging = false;
        });
      });
    }
    if (this.$props.isLoaded && this.$props.sliderCategory == "Game") {
      let gameSliderflkty = new Flickity(
        this.$refs.gameSlider,
        this.flickityAppOptions
      );
      gameSliderflkty.on("dragStart", function() {
        this.stageDragging = true;
      });
      gameSliderflkty.on("dragEnd", function() {
        this.stageDragging = false;
      });
    }
    if (this.$props.isLoaded && this.$props.sliderCategory == "Wallpaper") {
      this.$nextTick(() => {
        let wallPaperSliderflkty = new Flickity(
          this.$refs.wallpaperSlider,
          this.flickityVideoOptions
        );
        wallPaperSliderflkty.on("dragStart", function() {
          this.stageDragging = true;
        });
        wallPaperSliderflkty.on("dragEnd", function() {
          this.stageDragging = false;
        });
      });
    }
    if (this.$props.isLoaded && this.$props.sliderCategory == "Application") {
      this.$nextTick(() => {
        let wallPaperSliderflkty = new Flickity(
          this.$refs.applicationSlider,
          this.flickityAppOptions
        );
        wallPaperSliderflkty.on("dragStart", function() {
          this.stageDragging = true;
        });
        wallPaperSliderflkty.on("dragEnd", function() {
          this.stageDragging = false;
        });
      });
    }
  },
  methods: {
    getDetail(id) {
      this.$root.$emit("getDetail", id);
    }
  }
};
</script>
<style lang="scss" scoped>
/*###App Slider styles###*/
.d2-slider:before,
.d2-slider:after {
  content: "";
  display: block;
  width: 42px;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  pointer-events: none;
  transform: scale(1.2);
}
.d2-slider:after {
  left: -15px;
  right: auto;
  background: rgb(1, 17, 43);
  background: linear-gradient(
    90deg,
    rgba(1, 17, 43, 1) 13%,
    rgba(1, 17, 43, 0) 100%
  );
}
.d2-slider:before {
  right: -15px;
  left: auto;
  background: rgb(1, 17, 43);
  background: linear-gradient(
    270deg,
    rgba(1, 17, 43, 1) 13%,
    rgba(1, 17, 43, 0) 100%
  );
}

/*##### Responsive layout Styles#####*/
@media only screen and (max-width: 991px) {
}

@media only screen and (max-width: 589px) {
}
</style>



// WEBPACK FOOTER //
// src/components/gamebox/GameBoxSlider.vue